// Región de la INSTALACIÓN (formato de fechas, números y moneda).
// ERP Ecuador → 'es-EC' (por defecto). TrackConstruccion (EE. UU.) → VITE_REGION=en-US.
// La región es de la instalación, no del idioma: un usuario que trabaja en español
// en una empresa de EE. UU. sigue viendo fechas MM/DD/AAAA y montos 1,234.56.
export const LOCALE: string = (import.meta.env.VITE_REGION as string | undefined) || 'es-EC';

export const fmtMoneda = (v: number | string | null | undefined, moneda = 'USD') =>
  (Number(v) || 0).toLocaleString(LOCALE, { style: 'currency', currency: moneda });
export const fmtNumero = (v: number | string | null | undefined, decimales = 2) =>
  (Number(v) || 0).toLocaleString(LOCALE, { minimumFractionDigits: decimales, maximumFractionDigits: decimales });
export const fmtFecha = (v: string | Date | null | undefined) => {
  if (!v) return '—';
  const d = typeof v === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(v) ? new Date(v + 'T00:00:00') : new Date(v);
  return isNaN(d.getTime()) ? '—' : d.toLocaleDateString(LOCALE);
};
export const fmtFechaHora = (v: string | Date | null | undefined) => {
  if (!v) return '—';
  const d = new Date(v);
  return isNaN(d.getTime()) ? '—' : d.toLocaleString(LOCALE);
};

// Fecha local (AAAA-MM-DD) del navegador. NO usar toISOString().slice(0, 10): da la
// fecha UTC, que en América salta a «mañana» por la tarde/noche (20:00 en Nueva York,
// 17:00 en Los Ángeles, 19:00 en Ecuador).
export const fechaISO = (d: Date = new Date()) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
export const hoyISO = () => fechaISO();
